module.exports = __webpack_public_path__ + "img/Back-Arrow-Light.f47c2b2a.svg";